import {
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Form,
  Modal,
} from "reactstrap";
import { getProjectById, updateProject } from "src/slices/thunks";
import { format } from "date-fns";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "src";
import Select from 'react-select';

import useToast from "src/components/Common/toast";
import { useState } from "react";

const ProjectUpdate = ({
  selectedProject,
  modal,
  setModal,
  handleDelete,
  insideProjectOverview,
}: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const { show } = useToast();
  const users = useSelector((state: any) => state.users.users);
  const units = useSelector((state: any) => state.units.units.map(
      (unit:any) => ({
        value: unit.id,
        label: `${unit.name}`,
      })
  ));

  const responsibleUsers = useSelector((state: any) => state.users.users.map(
      (user:any) => ({
        value: user.profile__id,                    
        label: `${user.first_name} ${user.last_name}`,
      })
    ));

  
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      nome: selectedProject?.nome || "",
      project_descricao: selectedProject?.descricao || "",
      data_termino: selectedProject?.data_termino || "",
      data_real_termino: selectedProject?.data_real_termino || "",
      data_inicio: selectedProject?.data_inicio || "",
      status: selectedProject?.status || "",
      valor_previsto: selectedProject?.valor_previsto || 0,
      unidade_id: selectedProject ? units.filter((unit:any) =>
        selectedProject.unidade === unit.value
      ) : [],
      responsibles: selectedProject ? responsibleUsers.filter((user:any) =>
        selectedProject.responsaveis.some((responsa:any) => responsa.owner === user.value)
      ) : [],
      provenienciaFundo: selectedProject?.proveniencia_fundo || "",
    },

    onSubmit: values => {
      dispatch(updateProject({ id: selectedProject.id, ...values })).then(
        response => {
          if (typeof response.payload === "undefined") {
            show("Erro", "Erro ao actualizar actividade.");
          } else {
            setModal(false);
            insideProjectOverview && dispatch(getProjectById(selectedProject.id));
          }
        }
      );
    },
  });
  
  return (
    <Modal
      isOpen={modal}
      toggle={() => {setModal(!modal);}}
      centered={true}
      className="modal-lg"
      style={{ position: "relative" }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0">Editar Actividade</h5>
        <button type="button" onClick={() => {setModal(false);}}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form onSubmit={validation.handleSubmit}>
          <Row>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="nome">Nome da Actividade</Label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Insira o nome da tarefa"
                  id="nome"
                  name="nome"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.nome}
                  invalid={validation.touched.nome && validation.errors.nome ? true : false}
                />
                {validation.touched.nome && validation.errors.nome ? (
                    <FormFeedback type="invalid">{String(validation.errors.nome)}</FormFeedback>
                  ) : null
                }
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="status">Estado da Actividade</Label>
                <Input
                  name = "status"
                  type = "select"
                  className = "form-control"
                  onChange = {validation.handleChange}
                  onBlur = {validation.handleBlur}
                  value = {validation.values.status || ""}
                  invalid = {validation.touched.status && validation.errors.status ? true : false}
                >
                  <option value = "">Selecione o status</option>
                  <option value = "ACTIVO">Activo</option>
                  <option value = "FINALIZADO">Finalizado</option>
                </Input>
                {validation.touched.status && validation.errors.status ? (
                  <FormFeedback type = "invalid">
                    {String(validation.errors.status)}
                  </FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
            
          </Row>
          <Row>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="data_inicio">Data de Início</Label>
                <Flatpickr
                  placeholder="Selecione a data de início"
                  options={{altInput: true, altFormat: "F j, Y", dateFormat: "Y-m-d",}}
                  value={validation.values.data_inicio}
                  onChange={(date: Date[]) => {
                    const formattedDate = date.length ? format(date[0], "yyyy-MM-dd") : "";
                    validation.setFieldValue("data_inicio", formattedDate);
                  }}
                  onBlur={validation.handleBlur}
                  className={`form-control ${
                    validation.touched.data_inicio && validation.errors.data_inicio ? "invalid-field" : ""
                  }`}
                />
                {validation.touched.data_inicio &&
                validation.errors.data_inicio ? (
                  <FormFeedback type="invalid">
                    {String(validation.errors.data_inicio)}
                  </FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="data_termino">Data de Término</Label>
                <Flatpickr
                  placeholder="Selecione a data de término"
                  options={{altInput: true,altFormat: "F j, Y",dateFormat: "Y-m-d",}}
                  value={validation.values.data_termino}
                  onChange={(date: Date[]) => {
                    const formattedDate = date.length ? format(date[0], "yyyy-MM-dd"): "";
                    validation.setFieldValue("data_termino", formattedDate);
                  }}
                  onBlur={validation.handleBlur}
                  className={`form-control ${
                    validation.touched.data_termino && validation.errors.data_termino ? "invalid-field" : ""
                  }`}
                />
                {validation.touched.data_termino && validation.errors.data_termino ? (
                  <FormFeedback type="invalid">
                    {String(validation.errors.data_termino)}
                  </FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="data_real_termino">Data Real de Término</Label>
                <Flatpickr
                  placeholder="Selecione a data real de término"
                  options={{altInput: true,altFormat: "F j, Y",dateFormat: "Y-m-d",}}
                  value={validation.values.data_real_termino}
                  onChange={(date: Date[]) => {
                    const formattedDate = date.length ? format(date[0], "yyyy-MM-dd"): "";
                    validation.setFieldValue("data_real_termino", formattedDate);
                  }}
                  onBlur={validation.handleBlur}
                  className={`form-control ${
                    validation.touched.data_real_termino && validation.errors.data_real_termino ? "invalid-field" : ""
                  }`}
                />
                {validation.touched.data_real_termino && validation.errors.data_real_termino ? (
                  <FormFeedback type="invalid">
                    {String(validation.errors.data_real_termino)}
                  </FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="valor_previsto">Valor Previsto</Label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Insira o valor previsto"
                  id="valor_previsto"
                  name="valor_previsto"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.valor_previsto}
                  invalid={
                    validation.touched.valor_previsto && validation.errors.valor_previsto ? true : false
                  }
                />
                {validation.touched.valor_previsto && validation.errors.valor_previsto ? (
                  <FormFeedback type="invalid">
                    {String(validation.errors.valor_previsto)}
                  </FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>              
              <Label htmlFor="responsibles">Responsáveis</Label>
              <Select isMulti className="form-control" classNamePrefix="select" 
                options={responsibleUsers} 
                id="responsibles" 
                value={validation.values.responsibles}
                name="responsibles"
                onChange={(selectedOption:any, _:any) => validation.setFieldValue('responsibles', selectedOption)
              }/>
              {validation.touched.responsibles && validation.errors.responsibles ? (
                <FormFeedback type="invalid">{String(validation.errors.responsibles)}</FormFeedback>
              ) : null}             
            </Col>            
            <Col>
              <Label>Equipa</Label>
              <Select className="form-control" classNamePrefix="select" 
                options={units} id="unidade_id" 
                value={validation.values.unidade_id}
                name="unidade_id"
                onChange={(selectedOption:any, _:any) => validation.setFieldValue('unidade_id', selectedOption)
              }/>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup className = "mb-3">
                <Label htmlFor = "project_descricao">Descrição</Label>
                <Input
                  type = "textarea"
                  className = "form-control"
                  id = "project_descricao"
                  name = "project_descricao"
                  style = {{ height: "130px" }}
                  placeholder = "Insira a descrição da actividade"
                  onChange = {validation.handleChange}
                  onBlur = {validation.handleBlur}
                  value = {validation.values.project_descricao}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </div>

      <div className = "d-flex justify-content-end gap-2 modal-footer">
        <button type = "button" className = "btn btn-danger" onClick = {() => {
            handleDelete(selectedProject.id);setModal(false);
          }}>Apagar</button>
        <button type = "submit" onClick={() => {validation.handleSubmit();}} className="btn btn-primary">
          Salvar
        </button>
      </div>
    </Modal>
  );
};

export default ProjectUpdate;
